// Module
var code = "<menu-row items=\"vm.menu\" extra-items=\"vm.extraItems\" user-profile=\"vm.profile\"\n          on-logout=\"vm.logout()\"></menu-row>\n";
// Exports
module.exports = code;